<script setup lang="ts">
import { computed } from 'vue';
import type { CardBasic } from '@/types/pvp-card';
import { CardTypeIcon } from '../services/enum';
import AspectRatio from './AspectRatio.vue';

const props = defineProps<{ card: CardBasic }>();

// 根据 grade 动态设置费用样式类
const costClass = computed(() => `cost-${props.card.grade}`);
</script>

<template>
  <aspect-ratio :ratio="0.8">
    <div class="card-wrap">
      <template v-if="card">
        <div class="border" :class="[card.grade]">
          <!-- 费用显示：纯数字，小巧精致 -->
          <div class="card-cost" :class="costClass">
            {{ card.cost }}
          </div>

          <div class="card">
            <div class="type">{{ CardTypeIcon[card.type] }}</div>
            <div class="title">{{ card.name }}</div>
          </div>
        </div>
      </template>
      <div v-else class="loading-text">加载中...</div>
    </div>
  </aspect-ratio>
</template>

<style lang="scss" scoped>
.card-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: none;
}

.border {
  width: 100%;
  height: 100%;

  background-image: linear-gradient(to top, #f3e7e9 0%, #e3eeff 99%, #e3eeff 100%);
  box-shadow: 2px 2px 2px rgba(255, 255, 255, 0.4) inset, -2px -2px 2px rgba(100, 100, 100, 0.4) inset, 0 0 0 4px currentColor inset;
  overflow: hidden;
  border-radius: 4px;

  .card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 4px;

    .type {
      font-size: 20px;
    }

    .title {
      font-size: 12px;
      padding: 0 4px;
    }
  }
}

// 精致的小费用标签
.card-cost {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  z-index: 2;
  padding: 0;

  // 使用伪元素创建彩色背景圆点，避免破坏文字居中
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: inherit;
    border-radius: 17% 83% 56% 44% / 47% 48% 52% 53%;
    z-index: -1;
  }

  // 根据品级应用背景色（通过伪元素）
  &.cost-normal::before {
    background: linear-gradient(135deg, #6dd3d6, #2193b0);
  }

  &.cost-race::before {
    background: linear-gradient(135deg, #627CED, #3F62EC);
  }

  &.cost-epic::before {
    background: linear-gradient(135deg, #A16AC5, #8C4CB9);
  }

  &.cost-legend::before {
    background: linear-gradient(135deg, #ff6f61, #de6262);
  }
}

.loading-text {
  font-size: 12px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
</style>